import moment from 'moment'
import ft from '../featureToggle'

export default {
  getPackages (VueApp, callback, noFetching, itemToUpdate) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let selectedFilter = VueApp.$store.state.routing.selectedFilter

    let currentPage = VueApp.$store.state.routing.packages.paging.currentPage
    let request = {
      token: token,
      package: true,
      order: VueApp.$store.state.routing.packages.sort.order,
      orderAsc: VueApp.$store.state.routing.packages.sort.asc ? 1 : 0,
      pageNum: currentPage,
      pageSize: VueApp.$store.state.routing.packages.paging.pageSize
    }

    // Filter
    let filter = {}
    if (selectedFilter > -1) {
      filter = VueApp.$store.state.routing.reservationFilters[selectedFilter]
    }
    request['filter'] = filter

    // Search
    let search = VueApp.$store.state.routing.reservationSearch
    if (search !== '') {
      request['search'] = search
    }

    if (!noFetching) {
      VueApp.$store.commit('routing/setIsPackagesLoading', true)
    }
    VueApp.$sdk.post('/admin/package', request, r => {
      VueApp.$store.commit('routing/setIsPackagesLoading', false)
      if (r.error) {
        console.log('Error fetching package: ', r)
        callback(r)
        return
      }
      VueApp.$store.commit('routing/setRoutingPkgTotal', r.paging.totalItems)

      if (!r.list.length && currentPage === 1) {
        VueApp.$store.commit('routing/setPackageItems', [])
        return
      }

      let packages = []
      for (let i = 0; i < r.list.length; i++) {
        packages.push(self.formatPackage(VueApp, r.list[i]))
        if (currentPage > 1) {
          VueApp.$store.commit('routing/addPackage', self.formatPackage(VueApp, r.list[i]))
        }
      }
      if (currentPage === 1) {
        VueApp.$store.commit('routing/setPackageItems', packages)
      }

      if (packages.length > 0) {
        VueApp.$store.commit('routing/setPackageCurrentPage', r.paging.pageNum)
        VueApp.$store.commit('routing/setPackageTotalPages', r.paging.totalItems)
      }

      if (itemToUpdate && itemToUpdate.isPackage) {
        let itemsInDropzone = VueApp.$store.state.routing.dropzone.items
        let dropzoneItem = itemsInDropzone.filter(dropzone => dropzone.packageID === itemToUpdate.id)
        if (dropzoneItem.length > 0) {
          VueApp.$store.commit('routing/removeDropzoneItems', {
            id: itemToUpdate.id,
            type: 'package'
          })
          VueApp.$store.commit('routing/removeDropzonePackageDriver', itemToUpdate.id)
          let rsvp = packages.filter(opPackage => opPackage.id === itemToUpdate.id)
          if (rsvp.length > 0) {
            rsvp = rsvp[0]
            VueApp.$store.commit('routing/addDropzoneItem', rsvp)

            if (rsvp.driver !== null) {
              VueApp.$store.commit('routing/addDropzoneDriver', {
                packageID: rsvp.id,
                driver: rsvp.driver
              })
            }
          }
        }
      }
      callback(r)
    })
  },

  getReservations (VueApp, callback, noFetching, itemToUpdate) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let selectedFilter = VueApp.$store.state.routing.selectedFilter

    let currentPage = VueApp.$store.state.routing.reservations.paging.currentPage
    let request = {
      token: token,
      package: true,
      order: VueApp.$store.state.routing.reservations.sort.order,
      orderAsc: VueApp.$store.state.routing.reservations.sort.asc ? 1 : 0,
      search: VueApp.$store.state.routing.reservationSearch,
      pageNum: currentPage,
      pageSize: VueApp.$store.state.routing.reservations.paging.pageSize
    }

    // Filter
    let filter = {}
    if (selectedFilter > -1) {
      filter = VueApp.$store.state.routing.reservationFilters[selectedFilter]
    }
    request['filter'] = filter

    // Search
    let search = VueApp.$store.state.routing.reservationSearch
    if (search !== null || search !== '') {
      request['search'] = search
    }

    if (!noFetching) {
      VueApp.$store.commit('routing/setIsReservationsLoading', true)
    }
    VueApp.$sdk.post('/admin/rsvp/unpackaged', request, r => {
      VueApp.$store.commit('routing/setIsReservationsLoading', false)
      if (r.error) {
        console.log(r)
        callback(r)
        return
      }
      VueApp.$store.commit('routing/setRoutingRsvpTotal', r.paging.totalItems)

      if (!r.list.length && currentPage === 1) {
        VueApp.$store.commit('routing/setReservationItems', [])
        return
      }

      // console.log(r)
      let reservations = []
      for (let i = 0; i < r.list.length; i++) {
        reservations.push(self.formatRsvp(VueApp, r.list[i]))
        if (currentPage > 1) {
          VueApp.$store.commit('routing/pushRsvpItem', self.formatRsvp(VueApp, r.list[i]))
        }
      }
      if (currentPage === 1) {
        VueApp.$store.commit('routing/setReservationItems', reservations)
      }

      if (reservations.length > 0) {
        VueApp.$store.commit('routing/setReservationsCurrentPage', r.paging.pageNum)
        VueApp.$store.commit('routing/setReservationsTotalPages', r.paging.totalItems)
      }

      if (itemToUpdate && !itemToUpdate.isPackage) {
        let itemsInDropzone = VueApp.$store.state.routing.dropzone.items
        let dropzoneItem = itemsInDropzone.filter(dropzone => dropzone.reservationID === itemToUpdate.id && dropzone.packageID === null)
        if (dropzoneItem.length > 0) {
          VueApp.$store.commit('routing/removeDropzoneItems', {
            id: itemToUpdate.id,
            type: 'rsvp'
          })
          let rsvp = reservations.filter(reservation => reservation.id === itemToUpdate.id)
          if (rsvp.length > 0) {
            rsvp = rsvp[0]
            VueApp.$store.commit('routing/addDropzoneItem', rsvp)
          }
        }
      }
      callback(r)
    })
  },

  updateItemsInTables (VueApp, item) {
    let self = this
    self.getReservations(VueApp, () => {}, true, item)
    self.getPackages(VueApp, () => {}, true, item)
  },

  updateItemInTable (VueApp, rsvp) {
    let self = this

    let url = '/admin/rsvp/'
    if (rsvp.isPackage) {
      url = '/admin/package/'
    }
    VueApp.$sdk.get(url + rsvp.id, {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        console.log(r)
        return
      }

      let result = null
      if (r.package) {
        result = self.formatPackage(r)
      } else {
        result = self.formatRsvp(r)
      }
    })
  },

  initRoutingReservations (VueApp) {
    let self = this
    setTimeout(() => {
      let threshold = VueApp.$settings.get('OfferLimitThreshold')
      VueApp.$store.commit('routing/setBeThereTimeThreshold', 1 + (parseFloat(threshold) / 100))
    }, 1000)
    VueApp.$sdk.get('/admin/filters', {
      order: 'filterName',
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      if (r.error) {
        console.log(r)
        return
      }
      VueApp.$store.commit('routing/setReservationFilters', r.list)
      // Load last selected filter
      let selectedFilterId = parseInt(VueApp.$plugins.storage.get('ADMIN_ROUTING_FILTER'))
      if (isNaN(selectedFilterId)) {
        self.getReservations(VueApp, r => {}, false)
        self.getPackages(VueApp, r => {}, false)
        return
      }
      let selectedFilter = -1
      for (let i = 0; i < r.list.length; i++) {
        let filter = r.list[i]

        if (filter.id === selectedFilterId) {
          selectedFilter = i
          break
        }
      }

      if (selectedFilter >= 0) {
        VueApp.$store.commit('routing/setSelectedFilter', selectedFilter)
        // Jayrome TODO: Preload data
        self.getReservations(VueApp, r => {}, false)
        self.getPackages(VueApp, r => {}, false)
      }
    })
  },

  formatRsvp (VueApp, item) {
    let statusClass = item.dispatchStatus
    let status = item.dispatchStatus.toUpperCase()
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }

    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }

    if (statusClass === 'complete') {
      status = 'COMPLETED'
    }

    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    if (item.status === 'ontheway') {
      statusClass = 'ontheway'
      status = 'ONTHEWAY'
    }

    let phoneNumber = null
    if (item.consumer.phones && item.consumer.phones.length > 0) {
      let phone = item.consumer.phones[0]
      phoneNumber = '+' + phone.countryCode + phone.phoneNumber
    }

    let pickup = {
      address1: item.pickupLocation.addressLine1,
      address2: item.pickupLocation.addressLine2,
      city: item.pickupLocation.city,
      state: item.pickupLocation.state,
      zip: item.pickupLocation.zip,
      lat: item.pickupLocation.lat,
      lng: item.pickupLocation.lng,
      geofenceType: item.pickupLocation.geofenceType,
      geofenceName: item.pickupLocation.geofenceName,
      title: item.pickupLocation.title
    }
    let dropoff = {
      address1: item.dropoffLocation.addressLine1,
      address2: item.dropoffLocation.addressLine2,
      city: item.dropoffLocation.city,
      state: item.dropoffLocation.state,
      zip: item.dropoffLocation.zip,
      lat: item.dropoffLocation.lat,
      lng: item.dropoffLocation.lng,
      geofenceType: item.dropoffLocation.geofenceType,
      geofenceName: item.dropoffLocation.geofenceName,
      title: item.dropoffLocation.title
    }
    let pickupMoment = moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss')
    let threshold = VueApp.$store.state.routing.beThereTimeThreshold
    let maxDuration = Math.floor(item.etaInSec * threshold)
    let btt = pickupMoment.add(maxDuration, 'seconds')

    let legs = [] // stops
    legs.push({
      originalBTT: 0,
      eta: 0,
      inOrder: -1,
      isPickup: true,
      location: pickup,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: 0,
      packageID: null,
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      originalPickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status,
      serviceId: item.optinShared.isOptinShared ? item.optinShared.shared.serviceTypeId : 'shared'
    })
    legs.push({
      originalBTT: maxDuration,
      eta: item.etaInSec,
      inOrder: -1,
      isPickup: false,
      location: dropoff,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      maxDuration: maxDuration,
      packageID: null,
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      originalPickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      reservationID: item.ID,
      status: status,
      serviceId: item.optinShared.isOptinShared ? item.optinShared.shared.serviceTypeId : 'shared'
    })

    // let airline = item.dropoffAirline
    // let airlineCode = item.dropoffAirlineCode
    // let flightNumber = item.dropoffFlightNumber
    // if (item.airline) {
    //   airline = item.airline
    //   airlineCode = item.airlineCode
    //   flightNumber = item.flightNumber
    // }

    let flightName = item.airline
    let flightNumber = item.flightNumber
    let airlineCode = item.airlineCode
    let dropoffAirline = ''
    let dropoffFlightNumber = ''
    if (item.dropoffAirline || item.dropoffFlightNumber) {
      dropoffAirline = item.dropoffAirline
      airlineCode = item.dropoffAirlineCode
      dropoffFlightNumber = item.dropoffFlightNumber
    }
    return {
      id: item.ID,
      type: 'rsvp',
      statusClass: statusClass,
      status: status,
      pickupTime: moment(item.pickupDate, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      pickup: pickup,
      eta: item.etaInSec,
      beThereTime: btt.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      dropoff: dropoff,
      customer: {
        id: item.consumer.ID,
        firstName: item.consumer.firstName,
        lastName: item.consumer.lastName,
        phone: phoneNumber
      },
      flight: {
        airline: flightName || dropoffAirline,
        airlineCode: airlineCode,
        flightNumber: flightNumber || dropoffFlightNumber
      },
      airline: flightName,
      airlineCode: airlineCode,
      airportCode: item.airportCode,
      flightNumber: flightNumber,
      dropoffAirline: dropoffAirline,
      dropoffFlightNumber: dropoffFlightNumber,
      passengers: item.passengers,
      luggage: item.luggage !== null ? item.luggage : 0,
      payment: item.payment,
      legs: legs,
      ada: {
        wheelchair: item.ada.wheelChairLift === 1,
        serviceDog: item.ada.serviceDog === 1
      },
      pickupSectors: item.pickupLocation.sectors ? item.pickupLocation.sectors : null,
      dropoffSectors: item.dropoffLocation.sectors ? item.dropoffLocation.sectors : null,
      gasFee: item.gasFee || 0,
      optinShared: item.optinShared,
      service: item.serviceType,
      serviceId: item.optinShared.isOptinShared ? item.optinShared.shared.serviceTypeId : 'shared'
    }
  },

  formatPackage (VueApp, item) {
    let self = this
    // Status
    let statusClass = item.package.packageStatus
    let status = item.package.packageStatus.toUpperCase()
    if (statusClass === 'requires_dispatch') {
      statusClass = 'requires-dispatch'
      status = 'REQUIRES DISPATCH'
    }
    if (statusClass === 'autodispatch') {
      statusClass = 'auto-dispatch'
      status = 'AUTO DISPATCH'
    }
    if (statusClass === 'complete') {
      status = 'COMPLETED'
    }
    if (statusClass === 'ready') {
      status = 'READY TO GO'
    }

    // RSVP
    let ada = {
      serviceDog: 0,
      wheelChairLift: 0
    }
    let rsvps = []
    let luggage = 0
    let tip = 0
    let gasFee = 0
    
    for (let i = 0; i < item.rsvp.length; i++) {
      let rsvp = self.formatRsvp(VueApp, item.rsvp[i])
      luggage += rsvp.luggage
      rsvps.push(rsvp)
      if (rsvp.ada.wheelchair) {
        ada.wheelchair = true
      }
      if (rsvp.ada.serviceDog) {
        ada.serviceDog = true
      }
      tip = tip + rsvp.payment.tipAmount
      gasFee = gasFee + rsvp.gasFee
    }

    let legs = []
    for (let i = 0; i < item.stops.length; i++) {
      let leg = item.stops[i]
      let itemRsvp = rsvps.filter(rsvp => rsvp.id === leg.reservationID)[0]
      legs.push({
        originalBTT: itemRsvp.legs[1].maxDuration,
        eta: leg.eta,
        inOrder: leg.inOrder,
        isPickup: leg.isPickup,
        location: leg.isPickup ? itemRsvp.pickup : itemRsvp.dropoff,
        passengers: itemRsvp.passengers,
        luggage: itemRsvp.luggage !== null ? itemRsvp.luggage : 0,
        maxDuration: leg.maxDuration,
        packageID: item.package.id,
        pickupTime: moment(item.package.localPickupTime, 'YYYY-MM-DD hh:mm:ss').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
        originalPickupTime: moment(itemRsvp.pickupTime, 'MM/DD/YYYY hh:mmA').format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
        reservationID: leg.reservationID,
        status: itemRsvp.status,
        serviceId: itemRsvp.optinShared.isOptinShared ? itemRsvp.optinShared.shared.serviceTypeId : 'shared'
      })
    }

    let service = {
      color: '#fafafa',
      id: 0,
      label: 'MISSING'
    }
    if (item.rsvp.length) {
      service = item.rsvp[0].serviceType
    }
    let serviceId = 'shared'
    if (item.rsvp[0].optinShared.isOptinShared) {
      serviceId = item.rsvp[0].optinShared.shared.serviceTypeId
    }

    return {
      id: item.package.id,
      type: 'package',
      status: status,
      statusClass: statusClass,
      pickupTime: moment(item.package.localPickupTime).format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
      firstPickup: item.package.firstPickup,
      lastPickup: item.package.lastPickup,
      driver: item.driver,
      payment: item.package.paidForProvider,
      bonus: item.package.bonusToProvider,
      tip: tip,
      gasFee: gasFee || 0,
      ada: ada,
      stops: item.package.stops,
      pax: item.package.pax,
      luggage: luggage,
      rsvps: rsvps,
      legs: legs,
      inPool: item.package.inPool === 1,
      service: service,
      serviceId: serviceId,
      pendingOffer: {
        show: false,
        timer: 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/routing/reservations.js